import { Box, CircularProgress, Checkbox, FormControl, Grid, Select, Typography, MenuItem, Autocomplete, TextField, Card, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton ,Paper, TableFooter} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, set, useFormContext } from 'react-hook-form';
import { StepperContext } from '../BookingForm';
import { BookingDetailContext } from '../AddBooking';
import { BookingService } from '../Service';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Add, Delete, Remove } from '@mui/icons-material';
import { ProviderServices } from '../../Provider/CrudServices';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ExpertAndServices = () => {
    const {bookingData,setBookingData,chargeDetails, setChargeDetails,fetchedBookingData} = useContext(BookingDetailContext);
    const {activeStep, setActiveStep,completed, setCompleted,handleNext,handleBack,handleComplete,handleReset,setPreviousServices} = useContext(StepperContext);
    const {control,watch,formState:{isDirty},setValue} = useFormContext();

    const latitude = watch('latitude');
    const longitude = watch('longitude');
    const categoryId = watch('categoryId');
    const subCategoryId = watch('subCategoryId');
    const serviceExpert = watch('serviceExpert');
    const services = watch('services');

    const [loadingCategoryList,setLoadingCategoryList] = useState(false);
    const [categoryList,setCategoryList] = useState([]);
    const fetchCategoryList= async()=>{
        setValue('categoryId', '');
        setValue('subCategoryId','');
        setValue('serviceExpert','');
        setValue('services',[])
        setLoadingCategoryList(true);
        try {
          const categoryListResponse = await BookingService.categoryListByCoordinates({latitude:latitude,longitude:longitude});
          // console.log("category list Response:",categoryListResponse);
          if(categoryListResponse.success===1){
            setCategoryList(categoryListResponse.data)
          }
        } catch (error) {
          
        }finally{
          setLoadingCategoryList(false);
        }
    }
    useEffect(()=>{  
        // Update previous services
        setPreviousServices(bookingData.services);
        if (latitude && longitude) {
            fetchCategoryList();            
        }
    },[latitude,longitude]);

    const [loadingSubCategoryList,setLoadingSubCategoryList] = useState(false);
    const [subCategoryList,setSubCategoryList] = useState([]);
    useEffect(() => {
        if (categoryId) {
        //   if (categoryId!==bookingData.categoryId) {
        //     // reset({
        //     //   categoryId: categoryId,
        //     //   subCategoryId: '',
        //     //   serviceExpert: '',
        //     //   services: [],
        //     // });
            setValue('subCategoryId', '');
            setValue('serviceExpert', '');
        //     setValue('services', []);
        //   }
          const fetchSubCategoryList = async () => {
            setLoadingSubCategoryList(true);
    
            try {
              const subCategoryListResponse = await BookingService.subCategoryListByCoordinatesAndCategoryId({
                latitude: latitude,
                longitude: longitude,
                categoryId,
              });
              // console.log("subCategoryListResponse:",subCategoryListResponse);
              if (subCategoryListResponse.success === 1) {
                setSubCategoryList(subCategoryListResponse.data);
              }
            } catch (error) {
              // console.error("Failed to fetch sub-category list:", error);
            } finally {
              setLoadingSubCategoryList(false);
            }
          };
          fetchSubCategoryList();
        }
    }, [categoryId]);

    const [loadingServiceExpertList,setLoadingServiceExpertList] = useState(false);
    const [serviceExpertList,setServiceExpertList]=useState([]);  
    // whenever subcategory changes reset all the dependent fields like serviceexpert,services and fech service list and fetch service expert list
    useEffect(() => {
        if (subCategoryId) {
          if (subCategoryId!==bookingData.subCategoryId) {
            // reset({
            //   categoryId: categoryId,
            //   subCategoryId: subCategoryId,
            //   serviceExpert: '',
            //   services: [],
            // });
            setValue('serviceExpert', '');
            setValue('services', []);
          }
          const fetchServiceList = async () => {
            setLoadingServiceExpertList(true);
    
            try {
              const providerListResponse = await BookingService.providerListByCoordinatesAndSubCategoryId({
                latitude: latitude,
                longitude: longitude,
                subCategoryId,
              });
              console.log("providerListResponse:",providerListResponse);
              if (providerListResponse.success === 1) {
                setServiceExpertList(providerListResponse.data);
              }
            } catch (error) {
              // console.error("Failed to fetch service list:", error);
            } finally {
              setLoadingServiceExpertList(false);
            }
          };
          fetchServiceList();
        }
    }, [subCategoryId]);


    const [loadingServiceList,setLoadingServiceList] = useState(false);
    const [serviceList,setServiceList] = useState([]);
    const fetchSelectedExpertData = async()=>{
        try {
            const response = await ProviderServices.fetchProviderDetailsById(serviceExpert);
            const expertDetails = {
                ...response.data?.UserProfile,
                mobileNumber:response.data?.mobileNumber,
            }
            if(response.success===1){
                setBookingData({...bookingData,serviceExpertProfile:expertDetails});
                setChargeDetails({...chargeDetails,waiveVisitCharge:response.data?.UserProfile?.waiveVisitCharge});
            }
        } catch (error) {
            console.log("error:",error);
        }
    }
    // whenever serviceExpert changes reset all the dependent fields like services and fetch service list
    useEffect(() => {
        if (serviceExpert && subCategoryId) {
        //   if (serviceExpert!==bookingData.serviceExpert) {
        //     reset({
        //       categoryId: categoryId,
        //       subCategoryId: subCategoryId,
        //       serviceExpert: serviceExpert,
        //       services: [],
        //     });
        //   }
            // const eexpertData = await
            // const serviceExpertProfile = serviceExpertList.find(expert => expert.userId == serviceExpert);
            // setBookingData({...bookingData,serviceExpertProfile:serviceExpertProfile});
            fetchSelectedExpertData();
            setValue('services', []);
            const fetchServiceList = async () => {
                setLoadingServiceList(true);
        
                try {
                const serviceListResponse = await BookingService.serviceList({subCategoryId:subCategoryId,providerId:serviceExpert});
                // console.log("serviceListResponse:",serviceListResponse);
                if (serviceListResponse.success === 1) {
                    setServiceList(serviceListResponse.data);
                }
                } catch (error) {
                // console.error("Failed to fetch service list:", error);
                } finally {
                setLoadingServiceList(false);
                }
            };
            fetchServiceList();
        }
    }, [serviceExpert]);

    const [billCalculations,setBillCalculations] = useState({
        subTotal:0,
        total:0,
        remainingAmounttoWaiveVisitingCharge:0,
    });
    useEffect(()=>{
        if(services.length>0){
            // Function to find the highest visiting charge
            const highestVisitingCharge = Math.max(...services.map(service => parseFloat(service.charges.vistingCharge)));
            
            // Function to find the maximum additional charge
            const maxAdditionalCharge = Math.max(...services.map(service => parseFloat(service.charges.additionalCharge)));
            
            // Function to check if any service is not refundable
            const isAnyNotRefundable = services.some(service => !service.charges.isRefundable);
            
            // Function to find the minimum refundable amount
            const minRefundableAmount = Math.min(...services.map(service => parseFloat(service.charges.refundableAmount)));
            
            // Function to find the maximum refundable duration
            const maxRefundableDuration = Math.max(...services.map(service => service.charges.refundableDuration));

            // Funtion to  find minimum cancellation time
            const minCancellationTime = Math.min(...services.map(service => service.charges.timeLimitForCancellation));
            
            // Function to find the highest cancellation charge in percent
            const highestCancellationChargeInPercent = Math.max(...services.map(service => parseFloat(service.charges.cancellationChargeInPercent)));
            
            
            const subTotal= services.reduce((acc, service) => acc + (service.price * service.quantity), 0).toFixed(2);
            const visitingCharge = parseFloat(subTotal)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(0).toFixed(2):parseFloat(highestVisitingCharge).toFixed(2);
            const total = parseFloat(subTotal) + parseFloat(visitingCharge);
            const remainingAmounttoWaiveVisitingCharge = parseFloat(chargeDetails?.waiveVisitCharge) - parseFloat(subTotal);
            
            setBillCalculations({
                ...billCalculations,
                subTotal:subTotal,
                total:total,
                // total:parseFloat(subTotal)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(subTotal).toFixed(2):parseFloat(parseFloat(subTotal)+parseFloat(chargeDetails?.vistingCharge)).toFixed(2),
                remainingAmounttoWaiveVisitingCharge:remainingAmounttoWaiveVisitingCharge,
            });
            setChargeDetails({
                ...chargeDetails,
                vistingCharge:highestVisitingCharge,
                additionalCharge:maxAdditionalCharge,
                isRefundable:isAnyNotRefundable,
                refundableAmount:minRefundableAmount,
                refundableDuration:maxRefundableDuration,
                minCancellationTime:minCancellationTime,
                cancellationChargeInPercent:highestCancellationChargeInPercent,
            }); 
        }else{
            setChargeDetails({
                ...chargeDetails,
                vistingCharge:0,
                additionalCharge:0,
                isRefundable:false,
                refundableAmount:0,
                refundableDuration:0,
                minCancellationTime:0,
                cancellationChargeInPercent:0,
            });
            setBillCalculations({
                ...billCalculations,
                subTotal:0,
                total:0,
                remainingAmounttoWaiveVisitingCharge:0,
            });
        }
    },[services]);


    const handleQuantityChange = (id, quantity) => {
        const items = services.map(service => 
          service.id === id ? { ...service, quantity: parseInt(quantity) || 0,serviceTime:(service.serviceTime/service.quantity)* parseInt(quantity) || 0} : service
        );
        setValue('services',items,{
          shouldDirty: true,
          shouldTouch: true
        });
    };

    const handleDeleteService = (id) => {
        const updatedServices = services.filter(service => service.id !== id);
        // setSelectedServices(updatedServices);
        setValue('services', updatedServices); // Update the form value
    };
  return (
    <Grid container spacing={2} >
              {/* ............left section................... */}
        <Grid item xs={12} lg={5}>
            <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:(!latitude && !longitude)&&'lightGray'}}>Select Category<span style={{color:(!latitude && !longitude)?'lightGray':'#d32f2f'}}>*</span></Typography>
            <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                <Controller
                    name='categoryId'
                    control={control}
                    rules={{required:'select category'}}
                    render={({field,fieldState:{error}})=>(
                        <Autocomplete
                            fullWidth
                            {...field}
                            disabled={!latitude && !longitude}
                            options={categoryList}
                            getOptionLabel={(option) => option?.catTitle || ''}
                            isOptionEqualToValue={(option, value) =>
                                option.catId === (value?.catId || value)
                            }
                            onChange={(event, newValue) => {
                                field.onChange(newValue ? newValue.catId : null);
                            }}
                            value={categoryList.find(option => option.catId === field.value) || null}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    // label="Select SAC Code*"
                                    placeholder='Search and Select Category'
                                    error={!!error}
                                    // helperText={error ? error.message : ''}
                                    size="small"
                                    inputProps={{
                                        ...params.inputProps,
                                        style: { fontSize: '0.75rem' }
                                    }}
                                />
                            )}
                            renderOption={(props, option) => (
                                <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                {option.catTitle || ''}
                                </MenuItem>
                            )}
                        />
                    )}  
                />
                {loadingCategoryList && <CircularProgress/>}
            </Box>
        </Grid>
        <Grid item xs={0} lg={2}/>
        <Grid item xs={12} lg={5}>
            <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:!categoryId && 'lightGray'}}>Select Sub-Category<span style={{color:!categoryId?'lightGray':'#d32f2f'}}>*</span></Typography>
            <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                <Controller
                    name='subCategoryId'
                    control={control}
                    rules={{required:'select sub-category'}}
                    render={({field,fieldState:{error}})=>(
                        <Autocomplete
                            fullWidth
                            {...field}
                            disabled={!categoryId}
                            options={subCategoryList|| []}
                            getOptionLabel={(option) => option?.subCatTitle || ''}
                            isOptionEqualToValue={(option, value) =>
                                option.subCatId === (value?.subCatId || value)
                            }
                            onChange={(event, newValue) => {
                                field.onChange(newValue ? newValue.subCatId : null);
                            }}
                            value={subCategoryList.find(option => option.subCatId === field.value) || null}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    // label="Select SAC Code*"
                                    placeholder='Search and Select Sub-Category'
                                    error={!!error}
                                    // helperText={error ? error.message : ''}
                                    size="small"
                                    inputProps={{
                                        ...params.inputProps,
                                        style: { fontSize: '0.75rem' }
                                    }}
                                />
                            )}
                            renderOption={(props, option) => (
                                <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                    {option.subCatTitle || ''}
                                </MenuItem>
                            )}
                        />
                    )}  
                />
                {loadingSubCategoryList && <CircularProgress/>}
            </Box>
        </Grid>
        <Grid item xs={12} lg={5}>
            <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:!subCategoryId && 'lightGray'}}>Select Service Expert<span style={{color:!subCategoryId ? 'lightGray' : '#d32f2f'}}>*</span></Typography>
            <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                <Controller
                    name='serviceExpert'
                    control={control}
                    rules={{required:'Select Service Expert'}}
                    render={({field,fieldState:{error}})=>(
                        <Autocomplete
                            fullWidth
                            {...field}
                            disabled={!subCategoryId}
                            options={serviceExpertList|| []}
                            // getOptionLabel={(option) => option?.subCatTitle || ''}
                            getOptionLabel={(option) => {
                                if (!option) return '';
                                const expertLabel = option?.firstName ? `${option.firstName} ${option.lastName}` : '';
                                const mobileNumber = option?.mobileNumber ? `(${option.mobileNumber})` : '';
                                const distance = option?.distance ? `(${option.distance} km)` : '';
                                return `${expertLabel} | ${mobileNumber} | ${distance}`;
                              }}
                            isOptionEqualToValue={(option, value) =>
                                option.userId === (value?.userId || value)
                            }
                            onChange={(event, newValue) => {
                                field.onChange(newValue ? newValue.userId : null);
                            }}
                            value={serviceExpertList.find(option => option.userId === field.value) || null}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    // label="Select SAC Code*"
                                    placeholder='Search and Select Expert'
                                    error={!!error}
                                    // helperText={error ? error.message : ''}
                                    size="small"
                                    inputProps={{
                                        ...params.inputProps,
                                        style: { fontSize: '0.75rem' }
                                    }}
                                />
                            )}
                            renderOption={(props, option) => (
                                <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                    {option.firstName || '' + option.lastName || ''} | {option.mobileNumber || ''} | {option.distance+' '+'km' || ''}
                                </MenuItem>
                            )}
                        />
                    )}  
                />
                {loadingServiceExpertList && <CircularProgress/>}
            </Box>
        </Grid>
        <Grid item xs={0} lg={2}/>
        <Grid item xs={12} lg={5}>
            <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:!serviceExpert && 'lightGray'}}>Select Services<span style={{color:!serviceExpert ? 'lightGray': '#d32f2f'}}>*</span></Typography>
            <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                <Controller
                    name='services'
                    control={control}
                    rules={{ required: 'Select service' }}
                    render={({ field, fieldState: { error } }) => (
                      <Autocomplete
                        fullWidth
                        {...field}
                        multiple
                        disabled={!serviceExpert}
                        disableCloseOnSelect
                        options={serviceList}
                        getOptionLabel={(option) => option.title}
                        renderOption={(props, option, { selected }) => (
                          <li {...props} key={option.id} style={{fontSize:'0.75rem'}} > 
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.title}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            InputProps={{
                              ...params.InputProps,
                              style: { fontSize: '0.75rem',color:'#000' },
                            }}
                            size='small'
                            error={!!error}
                            variant="outlined"
                            placeholder="Select services"
                          />
                        )}
                        onChange={(_, newValue) => {
                          const servicesWithQuantity = newValue.map(service => ({
                            ...service,
                            quantity: service.quantity || 1
                          }));
                          field.onChange(servicesWithQuantity);
                        }}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        renderTags={() => null}
                      />
                    )}
                />
                {loadingServiceList && <CircularProgress />}
            </Box>
        </Grid>
        <Grid item xs={12} sx={{display:services.length>0?'block':'none'}}>
            <Box>
                <Typography sx={{fontWeight:'600',color:'#494949'}}>Service Details</Typography>
                <Card sx={{bgcolor:'#dadada4d'}}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',borderBottom:'1px solid #BEC2C2'}}>
                                <Typography sx={{fontWeight:500,color:'#3E3E3E'}}>Your Cart </Typography>
                                <Typography sx={{fontWeight:500,fontSize:'small',color:'#3E3E3E'}}>{services.length>0? services.length:''} Services</Typography>
                            </Box>
                            <Box>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{fontWeight:600,p:'1% 2%'}} width="40%" >Service</TableCell>
                                                <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Quantity</TableCell>
                                                <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Time</TableCell>
                                                <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Price</TableCell>
                                                <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Total</TableCell>
                                                <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="right" width="12%" >Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {services.map((service) => (
                                            <TableRow key={service.id}>
                                                <TableCell sx={{ p: 1 }}>{service.title}</TableCell>
                                                <TableCell align="center" sx={{ p: 1 }}>
                                                    <Paper sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                        <IconButton
                                                        size="small"
                                                        onClick={() => handleQuantityChange(service.id, Math.max(1, service.quantity - 1))}
                                                        >
                                                        <Remove sx={{color:'#1A44B8'}} fontSize='small'/>
                                                        </IconButton>
                                                        
                                                        <TextField
                                                        type="number"
                                                        value={service.quantity}
                                                        onChange={(e) =>{
                                                            // i want always value 1 or greater than 1
                                                            if(e.target.value<1){
                                                            e.target.value=1;
                                                            }
                                                            handleQuantityChange(service.id, e.target.value)
                                                        } }
                                                        inputProps={{ 
                                                            min: 1,
                                                            // className: 'quantity-input',
                                                            style: { 
                                                            textAlign: 'center', 
                                                            width: '2em',
                                                            '-moz-appearance': 'textfield',
                                                            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                                '-webkit-appearance': 'none',
                                                                margin: 0
                                                            }
                                                            } 
                                                        }}
                                                        size="small"
                                                        variant="standard"
                                                        sx={{ 
                                                            mx: 1,
                                                            "& .MuiInput-underline:before": { borderBottom: "none" },
                                                            "& .MuiInput-underline:after": { borderBottom: "none" },
                                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                            borderBottom: "none"
                                                            },
                                                            "& .MuiInputBase-input": {
                                                            borderLeft: "1px solid #ccc",
                                                            borderRight: "1px solid #ccc",
                                                            px: 0  // padding left and right
                                                            }
                                                        }}
                                                        />

                                                        <IconButton
                                                        size="small"
                                                        onClick={() => handleQuantityChange(service.id, service.quantity + 1)}
                                                        >
                                                        <Add fontSize='small' sx={{color:'#1A44B8'}}/>
                                                        </IconButton>
                                                    </Paper>
                                                </TableCell>
                                                <TableCell align="center" sx={{ p: 1 }}>
                                                    {service.serviceTime} mins
                                                </TableCell>
                                                <TableCell sx={{ p: 1 ,textAlign:'center'}}>₹{service.price}</TableCell>                                                                       
                                                <TableCell sx={{ p: 1 ,textAlign:'center'}} >₹{parseFloat(service.price*service.quantity).toFixed(2)}</TableCell>
                                                <TableCell align="right" sx={{ p: 1 }}>
                                                    <IconButton
                                                        aria-label="delete"
                                                        onClick={() => handleDeleteService(service.id)}
                                                        size="small"
                                                        color='error'
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                            ))}
                                            {/* Charges Section */}
                                            <TableRow sx={{P:0}}>
                                                <TableCell rowSpan={'2'} colSpan={2}/>
                                                <TableCell  sx={{textAlign:'right', fontWeight:'600',borderBottom:'none',p:1}} colSpan={2}>SubTotal:</TableCell>
                                                {/* // sum of total of each service */}
                                                <TableCell sx={{textAlign:'right',borderBottom:'none',p:1}}>₹{billCalculations.subTotal}</TableCell>
                                                {/* <TableCell sx={{textAlign:'right',borderBottom:'none'}}>{}</TableCell> */}
                                            </TableRow>
                                            
                                            <TableRow sx={{borderBottom:'1px solid lightGray'}}>
                                            <TableCell  
                                                sx={{
                                                textAlign:'right',
                                                // borderBottom:'none',
                                                p:1
                                                }} 
                                                colSpan={2}
                                            >
                                                Visiting Charge:
                                            </TableCell>
                                            <TableCell 
                                                sx={{
                                                textAlign:'right',
                                                // borderBottom:'none',
                                                p:1
                                                }}
                                            >
                                                ₹{parseFloat(billCalculations.subTotal)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(0).toFixed(2):parseFloat(chargeDetails?.vistingCharge).toFixed(2)}
                                                {/* ₹{parseFloat(services.reduce((acc, service) => acc + (service.price * service.quantity), 0)).toFixed(2)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(0).toFixed(2):parseFloat(chargeDetails?.vistingCharge).toFixed(2)} */}
                                            </TableCell>
                                            </TableRow>                          
                                            {/* <TableRow>
                                                <TableCell  sx={{textAlign:'right',p:1}} colSpan={2}>Additional Charge:</TableCell>
                                                <TableCell 
                                                    sx={{textAlign:'right',
                                                    // borderBottom:'none', 
                                                        
                                                        position: 'relative',
                                                        '&::before': {
                                                        content: '"₹"',
                                                        }
                                                        ,p:1
                                                    }}
                                                >
                                                {parseFloat(chargeDetails?.additionalCharge).toFixed(2)}
                                                </TableCell>
                                            </TableRow> */}
                                            {/* <TableRow>
                                                <TableCell sx={{textAlign:'right',p:1}} colSpan={2}>waive Visit Charge:</TableCell>
                                                <TableCell sx={{textAlign:'right',p:1}} >₹{parseFloat(chargeDetails?.waiveVisitCharge).toFixed(2)}</TableCell>
                                            </TableRow> */}
                                            
                                            <TableRow>
                                                <TableCell colSpan={4} sx={{
                                                    textAlign:'right', 
                                                    fontWeight:'600',
                                                    borderBottom: 'none',p:1
                                                }}>Total:</TableCell>
                                                <TableCell sx={{
                                                    textAlign:'right',
                                                    fontWeight:'600',
                                                    borderBottom: 'none',p:1
                                                }}>
                                                    {/* sum of subtotal and above all charges */}
                                                    ₹{parseFloat(billCalculations.total).toFixed(2)}
                                                    {/* {selectedBookingDetails?.total} */}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    <Box sx={{p:'1%'}}>
                                        <Typography sx={{width:'100%',fontSize:'0.75rem',color:'#3e3e3e'}}>
                                            {billCalculations.remainingAmounttoWaiveVisitingCharge>0 && `Add more items worth ₹${billCalculations.remainingAmounttoWaiveVisitingCharge} to waive visiting charge`}
                                        </Typography>
                                    </Box>
                                </TableContainer>
                            </Box>
                        </Grid>
                    </Grid>
                </Card>
            </Box>
        </Grid>
    </Grid>
  );
}

export default ExpertAndServices;
